import { ARTICLE_STATUSES } from '../../constants/products';

export function getShouldShowCompare(articleStatus) {
  return (
    !articleStatus ||
    articleStatus === ARTICLE_STATUSES.ACTIVE ||
    articleStatus === ARTICLE_STATUSES.DISCONTINUED ||
    articleStatus === ARTICLE_STATUSES.BACKORDER
  );
}
